import * as contact from '~web/i18n/spanish/contact.es.i18n.json';
import * as core from '~web/i18n/spanish/core.es.i18n.json';
import * as customEvent from '~web/i18n/spanish/custom-event.es.i18n.json';
import * as discover from '~web/i18n/spanish/discover.es.i18n.json';
import * as error from '~web/i18n/spanish/error.es.i18n.json';
import * as event from '~web/i18n/spanish/event.es.i18n.json';
import * as form from '~web/i18n/spanish/form.es.i18n.json';
import * as login from '~web/i18n/spanish/login.es.i18n.json';
import * as menu from '~web/i18n/spanish/menu.es.i18n.json';
import * as meta from '~web/i18n/spanish/meta.es.i18n.json';
import * as myYoop from '~web/i18n/spanish/my-yoop.es.i18n.json';
import * as profile from '~web/i18n/spanish/profile.es.i18n.json';
import * as promoter from '~web/i18n/spanish/promoter.es.i18n.json';
import * as seating from '~web/i18n/spanish/seating.es.i18n.json';
import * as staticPages from '~web/i18n/spanish/static-pages.es.i18n.json';
import * as streaming from '~web/i18n/spanish/streaming.es.i18n.json';
import * as token from '~web/i18n/spanish/token.es.i18n.json';
import * as transaction from '~web/i18n/spanish/transaction.es.i18n.json';
import * as timezone from '~web/i18n/spanish/timezone.es.i18n.json';

export const spanish = {
  ...core,
  ...contact,
  ...customEvent,
  ...discover,
  ...error,
  ...event,
  ...form,
  ...login,
  ...menu,
  ...meta,
  ...myYoop,
  ...profile,
  ...promoter,
  ...seating,
  ...staticPages,
  ...streaming,
  ...timezone,
  ...transaction,
  ...token,
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/i18n/spanish.ts